// extracted by mini-css-extract-plugin
export default {"close":"Toast_close__Yev+c","main":"Toast_main__ryvng","title":"Toast_title__kLaoZ"};